module.exports = __webpack_public_path__ + "img/pc-img3-618.cf9e91d2.png";